import type { ComposerTranslation } from 'vue-i18n'

/** 与 zh-CN `listColumns` 对齐的叶子 key，用于列表列标题去重 */
export type ListColumnLeaf =
  | 'computerName'
  | 'terminalName'
  | 'group'
  | 'groupName'
  | 'userMark'
  | 'username'
  | 'ipAddress'
  | 'macAddress'
  | 'operation'
  | 'detail'
  | 'rawData'
  | 'softwareName'
  | 'softVersion'
  | 'fileName'
  | 'fileSize'
  | 'filePath'
  | 'fileType'
  | 'triggerTime'
  | 'operateTime'
  | 'triggerPolicy'
  | 'triggerResult'
  | 'loginTime'
  | 'loginSourceIp'
  | 'loginProtocol'
  | 'loginAccount'
  | 'loginRole'
  | 'result'
  | 'remark'
  | 'status'
  | 'time'
  | 'createTime'
  | 'port'
  | 'serviceName'
  | 'lastExamTime'
  | 'examStatus'
  | 'lastExamScore'
  | 'deviceName'
  | 'deviceType'
  | 'deviceId'
  | 'accessTime'
  | 'dataSource'
  | 'ransomwareEventCount'

export function listCol(t: ComposerTranslation, key: ListColumnLeaf): string {
  return t(`listColumns.${key}`)
}

/** 两段列名拼接，如「计算机名/分组」；英文为「Computer name / Group」 */
export function listColPair(
  t: ComposerTranslation,
  left: ListColumnLeaf,
  right: ListColumnLeaf
): string {
  return t('listColumns.labelPair', {
    left: t(`listColumns.${left}`),
    right: t(`listColumns.${right}`),
  })
}
